<ng-container *ngIf="agentNumber$ | async as agentNumber">
  <nx-message *ngIf="processService.isNavigation" context="info" class="nx-margin-top-m">
    <span class="nx-font-weight-bold">{{ 'affiliate-links-info.title' | translate }}</span>
    <ul>
      <li>
        <p class="azt-test" nxCopytext="normal">{{ 'affiliate-links-info.all-insurance-title' | translate }}</p>
        <nx-link>
          <a [href]="affiliateLink + agentNumber" target="_blank">{{ affiliateLink + agentNumber }}</a>
        </nx-link>
        <p class="azt-test" nxCopytext="normal" *ngFor="let item of 'affiliate-links-info.all-insurance' | translate">{{ item }}<br /></p>
      </li>
      <li>
        <p class="azt-test" nxCopytext="normal">{{ 'affiliate-links-info.resignation-insurance-title' | translate }}</p>
        <nx-link>
          <a [href]="affiliateLink + agentNumber" target="_blank">{{ affiliateLink + agentNumber }}&path=resignation</a>
        </nx-link>
      </li>
    </ul>
    <app-loader *ngIf="isDownloadAssetsLoaderShown | async; else downloadButton" ></app-loader>
    <ng-template #downloadButton>
      <button class="mt-8" nxButton="primary small" (click)="downloadMarketingAssets$.next()">
        <nx-icon [name]="'download'" class="mr-1" />
        <p class="azt-test">{{ 'affiliate-links-info.download-marketing-assets' | translate }}</p>
      </button>
    </ng-template>
  </nx-message>
</ng-container>
